module.exports = __webpack_public_path__ + "static/media/roller_skates.58d0b3a6.jpg";